import {Client} from '@stomp/stompjs';
import {AuthService} from '@services/AuthService';

export function createStompChatClient(): Client {
    const client = new Client({
        brokerURL: '/api/ws/chat',
        connectHeaders: {Authorization: `Bearer ${AuthService.getToken()}`},
        reconnectDelay: 5000,
        heartbeatIncoming: 10000,
        heartbeatOutgoing: 10000,
        beforeConnect: async () => {
            await AuthService.refreshToken();
            client.connectHeaders.Authorization = `Bearer ${AuthService.getToken()}`;
        },
        onDisconnect: (receipt) => {
            console.log('STOMP disconnected:', receipt);
        },
        onStompError: (frame) => {
            console.error('STOMP error:', frame.headers['message'], frame.body);
        },
        onWebSocketError: (error) => {
            console.error('WebSocket error:', error);
        },
    });

    return client;
}
